export class GlobalVars {
    // Variable globale
    public static maxFileSize: string = '1000000';

    public static colors = {
        observation: '#4791ff',
        simulation: 'red',
        noRain: 'mediumvioletred',
        tenYearDry: 'orange',
        twentyYearDry: 'gold',
        average: 'lightgreen',
        fiveYearWet: 'deepskyblue',
        tenYearWet: 'mediumblue',
        pluie: "#72C3CD",
        piezo: "#0000CD",
        piezoRealtime: "#32CD32",
        debit: "#D6880B",
        debitRealtime: "#FFFF00",
        depth: "#106FDF",
        depth_altitude: "#565757",
        ips_dix_ans_sec: "#C50E0E",
        ips_cinq_ans_sec: "#F05200",
        ips_deux_ans_sec: "#F8930F",
        ips_mediane: "#FFDE1A",
        ips_deux_ans_hum: "#FFDE1A",
        ips_cinq_ans_hum: "#60A3D6",
        ips_dix_ans_hum: "#3071B0",
        ips_sup_dix_ans_hum: "#00408B",
    };

    public static initialCoord = [2.5159, 47.4];
    public static initialZoom = 6;
    // Zoom de changement de détail pour la couche des secteur simplifiés
    public static wfsSimplifiedMaxZoomAndSensors = 8.5;

    // Liste des layers pour la couche des secteurs
    public static sectorLayers = {
        simplified: 'view_global_indicator_details',
        detailed: 'view_global_indicator_details'
    }

    public static sectorLayersType = {
        simplified: 'simplified',
        detailed: 'detailed'
    }

    public static projL93 = "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";
    public static projWgs84 = "+proj=longlat +datum=WGS84 +no_defs";

    public static bbboxFrance = "ymin=41.822903801890334&ymax=50.932436315157986&xmin=-9.954484318020405&xmax=15.057157651805031"
}
